import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { IdentityService } from 'src/app/_services/identity.service';


@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.css']
})
export class ForgetPasswordComponent implements OnInit {


  submitted=false;
   definitionForm:FormGroup;

  
   constructor(
     private formBuilder:FormBuilder,
     private activeModal:NgbActiveModal,
     private hammaddeService:IdentityService,
    
     private toastr: ToastrService
     
   ) { }
 
   ngOnInit() {
 
    this.definitionForm = this.formBuilder.group({
      username: ['', Validators.required],
      password:['cx']
    });
  }

  save(){
    this.submitted=true;
    if(this.definitionForm.invalid){
      return;
    }

    this.hammaddeService.forgetPassword(this.definitionForm.value).subscribe(res=>{
      this.toastr.success("Şifreniz eposta adresinize iletildi.","Success");
      this.activeModal.close();
      this.submitted=false;
    },err=>{
         this.submitted=false;
      this.toastr.error(err.error.message || err.message || "An error occured","Error");
    });
  }


  close(){
    this.activeModal.close();
  }
}
